/*
 * Copyright (c) 2020  Apricad LLC. All Rights Reserved.
 */

import * as React from "react";
import { useEffect } from "react";
import { makeStyles } from "@material-ui/core/styles";
import { useTheme } from "@material-ui/core/styles";
import { connect } from "react-redux";

import legalPageStyle from "assets/jss/views/legalPage/legalPageStyle";
const useStyles = makeStyles(legalPageStyle);

import { getDoc, ApricotAction } from "client/actions/modal";
import { progressCircles } from "components/Form/FormField";

interface Props {
  getDoc: ApricotAction;
  docAboutUs: string;
  classes: any;
}

const AboutUsBase: React.FC<Props> = ({ getDoc, docAboutUs }: Props) => {
  const classes = useStyles();
  const { palette } = useTheme();

  useEffect(() => {
    docAboutUs === null && getDoc(0);
  }, []);

  const HtmlToReactParser = require("html-to-react").Parser;
  const parser = new HtmlToReactParser();

  return docAboutUs ? (
    <div className={classes.content}>
      <div className={classes.title}>About Us</div>
      {parser.parse(docAboutUs)}
      <p>
        (Apricad is a combination of&#32;
        <span style={{ color: palette.primary.main }}>
          <b>Apricot</b>&#32;
        </span>
        &#32;and&#32;
        <span style={{ color: palette.secondary.main }}>
          <b>Caduceus</b>
        </span>
        , the acdemic color and symbol representing Nursing.)
      </p>
      <p className={classes.ending}>&sect;</p>
    </div>
  ) : (
    progressCircles()
  );
};

function mapStateToProps(state: any) {
  return {
    docAboutUs: state.state_modal.docAboutUs,
  };
}

const base: any = AboutUsBase;
const AboutUs = connect(mapStateToProps, { getDoc })(base);
export default AboutUs;
